/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
import { Flex, FormControl, FormLabel, Text, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaPlus } from 'react-icons/fa'
import Modal from 'react-modal'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { InputCmp } from '../../../../../components/InputCmp'
import { appApi } from '../../../../../services/appApi'
import { iNivelCargo } from '../ModalCreate'
import { WhiteModal } from '../ModalCreate/styles'
import { v4 as uuidv4 } from 'uuid'

interface iModalProps {
  isOpen: boolean
  onSave: (selecionado: string) => void
  onClose: () => void
  nivel?: iNivelCargo
}

interface iNivelInvalidFlags {
  ListaNiveisVaziaTrue: boolean
  AlgumNivelVazioTrue: boolean
  NomeTrue: boolean
}

export const ModalNivel: React.FC<iModalProps> = ({ isOpen, onClose, onSave, nivel }) => {
  const toast = useToast()
  const [Nivel, setNivel] = useState<iNivelCargo>({ id: '', nome: '', niveis: [''] })
  const [IsLoading, setIsLoading] = useState(false)
  const [nivelInvalidFlags, setNivelInvalidFlags] = useState<iNivelInvalidFlags>({
    ListaNiveisVaziaTrue: false,
    AlgumNivelVazioTrue: false,
    NomeTrue: false
  })

  function postNivel(): void {
    const next = { ...nivelInvalidFlags }
    let firstMessage: string | null = null
    let anyInvalid = false

    const mark = (failed: boolean, key: keyof typeof next, msg: string): void => {
      if (failed) {
        next[key] = true
        anyInvalid = true
        if (!firstMessage) firstMessage = msg
      } else {
        next[key] = false
      }
    }

    const listaVazia = !Array.isArray(Nivel.niveis) || Nivel.niveis.length === 0
    mark(listaVazia, 'ListaNiveisVaziaTrue', 'Coloque pelo menos um nível')

    const temNivelVazio = Array.isArray(Nivel.niveis) && Nivel.niveis.some(n => !n || n.trim() === '')
    mark(temNivelVazio, 'AlgumNivelVazioTrue', 'Preencha os campos dos níveis corretamente')

    const nomeVazio = !Nivel.nome || Nivel.nome.trim() === ''
    mark(nomeVazio, 'NomeTrue', 'Preencha o nome corretamente')

    setNivelInvalidFlags(next)

    if (anyInvalid) {
      toast({
        title: firstMessage ?? 'Há campos inválidos',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    setIsLoading(true)
    if (nivel) {
      appApi.put(`api/NivelCargo/${nivel.id}`, { ...Nivel, niveis: Nivel.niveis.map(e => e.includes(' ') ? e.replaceAll(' ', '_') : e) })
        .then(res => {
          onSave(res.data)
          setNivel({ id: '', nome: '', niveis: [''] })
          toast({
            title: 'Nível atualizado com sucesso',
            status: 'success',
            duration: 4000,
            position: 'top'
          })
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false))
    } else {
      appApi.post('api/NivelCargo', { ...Nivel, niveis: Nivel.niveis.map(e => e.includes(' ') ? e.replaceAll(' ', '_') : e), id: uuidv4() })
        .then(res => {
          onSave(res.data)
          setNivel({ id: '', nome: '', niveis: [''] })
          toast({
            title: 'Nível criado com sucesso',
            status: 'success',
            duration: 4000,
            position: 'top'
          })
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false))
    }
  }

  function UpdateArray(pos: number, texto: string): void {
    const copy = [...Nivel.niveis]
    copy[pos] = texto
    setNivel({ ...Nivel, niveis: copy })
  }

  useEffect(() => {
    if (nivel) {
      setNivel({ ...nivel, niveis: nivel.niveis.map(e => e.includes('_') ? e.replaceAll('_', ' ') : e) })
    } else {
      setNivel({ id: '', nome: '', niveis: [''] })
    }
  }, [nivel])

  useEffect(() => {
    if (!isOpen) {
      setNivelInvalidFlags({
        ListaNiveisVaziaTrue: false,
        AlgumNivelVazioTrue: false,
        NomeTrue: false
      })
    }
  }, [isOpen])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName='react-modal-overlay'
      className='react-modal-content-default'
    >
      <WhiteModal style={{ width: '52rem' }}>
        <FormControl>
          <Flex flexDir={'column'} alignItems={'center'} justifyContent={'center'} mb={'.25rem'}>
            <Text fontSize={'1.375rem'} lineHeight={'1.5rem'} fontWeight={'700'} textAlign={'center'}>Nível</Text>
					  <Text fontSize={'.813rem'} color={'var(--Red)'} fontWeight={'600'} textAlign={'center'}>Crie e/ou edite os níveis de um cargo</Text>
          </Flex>
          <InputCmp label='Nome' OnChange={(e) => { setNivel({ ...Nivel, nome: e }) }} value={Nivel.nome} isInvalid={nivelInvalidFlags.NomeTrue && Nivel.nome === ''}/>
          <Flex flexDir={'column'} gap={'.5rem'} width={'100%'} mt={'1rem'}>
            <FormLabel mr={'0'} color={'var(--Gray1)'} fontSize={'14px'} wordBreak={'keep-all'} mb={0}>Níveis</FormLabel>
            {
              Nivel?.niveis.map((e, i) => {
                return (
                  <InputCmp
                    value={e}
                    OnRemove={() => setNivel({ ...Nivel, niveis: Nivel.niveis.filter(n => n !== e) })}
                    OnChange={(r) => UpdateArray(i, r)}
                    isInvalid={(nivelInvalidFlags.AlgumNivelVazioTrue || nivelInvalidFlags.ListaNiveisVaziaTrue) && e === ''}
                  />
                )
              })
            }
            <ButtonCmp VarColor='Green2' width={'6rem'} onClick={() => setNivel({ ...Nivel, niveis: [...Nivel.niveis, ''] })}><FaPlus/></ButtonCmp>
          </Flex>
        </FormControl>

        <Flex justifyContent={'end'} gap={'.5rem'} mt={'.75rem'}>
          <ButtonCmp VarColor='c6' onClick={onClose}>Voltar</ButtonCmp>
          <ButtonCmp isLoading={IsLoading} VarColor='Green2' onClick={() => postNivel()}>Salvar</ButtonCmp>
        </Flex>
      </WhiteModal>
    </Modal>
  )
}
